export default __webpack_public_path__ + "static/media/Head_2_Ear_1_C2.c20e3956.svg";